import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=a54a7624&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/setting.css?vue&type=style&index=0&id=a54a7624&lang=css&scoped=true&"
import style1 from "./setting.vue?vue&type=style&index=1&id=a54a7624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54a7624",
  null
  
)

export default component.exports